




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { pageClicked, pageClickedBeacon } from '@utils/analytics';
import { isWebview } from '@utils/client';
import { Link } from 'types/layout';

@Component
export default class BaseLink extends Vue {
	@Prop()
	private link!: Link;

	@Prop()
	private classes!: string;

	@Prop()
	private clickText?: string;

	appBasePath = process.env.VUE_APP_BASE_PATH;

	get useRouterLink(): boolean {
		return !!this.link.router && !isWebview();
	}

	get href(): string {
		if (this.link.router) {
			const route = this.$router.resolve({
				name: this.link.router,
				params: this.link.params,
				hash: this.link.hash
			});
			return route.route.fullPath;
		} else {
			let returnedHref = '';
			if (this.link.href) {
				const uris = ['http://', 'https://', 'mailto:'];
				if (uris.some((uri) => this.link.href?.startsWith(uri))) {
					return this.link.href;
				}

				returnedHref = this.appBasePath + this.link.href;
			}

			return returnedHref;
		}
	}

	handleTracking(): void {
		const slot = this.$slots?.default ? this.$slots.default ?? undefined : [this.$vnode] ?? undefined;
		const clickText = this.clickText;
		if (this.useRouterLink) {
			pageClicked({ slot, clickText });
		} else {
			pageClickedBeacon({
				slot,
				parentElement: this.$el?.parentElement ?? undefined,
				link: this.link,
				clickText: clickText
			});
		}
	}
}
